const $$splitPendingComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/view-all.tsx?tsr-split=pendingComponent');
const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/view-all.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { ZnglyVideosFrontendQuery, type ZnglyVideos_Frontend_Pagination_Fragment$key, type ZnglyVideos_Frontend_Query } from '@/graphql/queries/ZnglyVideo.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { usePaginationFragment } from '@/graphql/relay.utils';
import { useAppStore } from '@/inertia/AppStore';
import { createFileRoute } from '@tanstack/react-router';
import { loadQuery } from 'react-relay';
type Props = {
  isFallback?: boolean;
} & Partial<ReturnType<typeof usePaginationFragment<ZnglyVideos_Frontend_Query, ZnglyVideos_Frontend_Pagination_Fragment$key>>>;
export const Route = createFileRoute('/view-all')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  loader: () => {
    return loadQuery<ZnglyVideos_Frontend_Query>(RelayEnvironment, ZnglyVideosFrontendQuery, {}, {
      fetchPolicy: 'store-or-network'
    });
  },
  pendingComponent: lazyRouteComponent($$splitPendingComponentImporter, 'pendingComponent'),
  onEnter: () => {
    useAppStore.getState().resetInertia();
    useAppStore.getState().setPageType('view-all');
  }
});